"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AcdcContext_1 = require("./AcdcContext");
var useAcdcReducer_1 = require("./useAcdcReducer");
var useAcdcInputProps_1 = __importDefault(require("./useAcdcInputProps"));
var visuallyHiddenStyle = {
    border: 'none',
    outline: 'none',
    padding: 0,
    width: 1,
    height: 0,
    color: 'transparent',
    opacity: 0,
    position: 'absolute',
    transform: 'scale(0)',
    WebkitTransform: 'scale(0)',
    msTransform: 'scale(0)',
};
function useAcdcInputButtonProps() {
    var _a = AcdcContext_1.useAcdcContext(), dispatch = _a.dispatch, isOpen = _a.state.isOpen;
    var _b = __read(useAcdcInputProps_1.default(), 1), _c = _b[0], onChange = _c.onChange, onClickInput = _c.onClick, onKeyDownInput = _c.onKeyDown, value = _c.value, ref = _c.ref, id = _c.id, labelledBy = _c["aria-labelledby"], props = __rest(_c, ["onChange", "onClick", "onKeyDown", "value", "ref", "id", 'aria-labelledby']);
    var onMouseDown = react_1.useCallback(function () {
        requestAnimationFrame(function () {
            var el = ref.current;
            if (el && !el.contains(document.activeElement)) {
                el.focus();
            }
        });
    }, [ref]);
    var onKeyDown = react_1.useCallback(function (e) {
        onKeyDownInput(e);
        if (e.key === ' ') {
            dispatch({ type: useAcdcReducer_1.ActionTypes.KeyDownEnter });
        }
        if (isOpen && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
        }
    }, [onKeyDownInput, isOpen]);
    var onClick = react_1.useCallback(function () { return dispatch({ type: useAcdcReducer_1.ActionTypes.InputClick }); }, [dispatch]);
    return [__assign({ id: id,
            onMouseDown: onMouseDown,
            onKeyDown: onKeyDown,
            onClick: onClick,
            ref: ref, 'children': react_1.default.createElement("input", { readOnly: true, style: visuallyHiddenStyle, "aria-labelledby": labelledBy, tabIndex: -1 }), 'aria-labelledby': labelledBy + " " + id }, props)];
}
exports.default = useAcdcInputButtonProps;
